import React from 'react';
import PrematchEventPreview from '../EventPreview';
import LiveEventPreview from '../../live/event/EventPreview';
import Img from '../../common/Img';
import DraggableScroller from '../../common/DraggableScroller';

export default function EventsScroller(props) {
    const events = props.data;

    if (events == null || events.length === 0) {
        return null;
    }
    
    return (
        <div className="c_49">
            <div className="c_49_1">
                <Img className="c_49_1_1" src={props.icon} height="16px" width="16px" />
                <div className="c_49_1_2">{props.title}</div>
            </div>
            <div className="c_49_2">
                <DraggableScroller className="c_49_2_1">
                    {events.map(e =>
                        e.isLive ?
                            <LiveEventPreview key={e.uniqueId} data={e} showFullDesc={true} type="small" linksAreDivs={true} />
                            :
                            <PrematchEventPreview key={e.uniqueId} data={e} showFullDesc={true} showPinButton={true} type="small" linksAreDivs={true} />
                    )}
                </DraggableScroller>
                <div className="c_49_2_2"></div>
            </div>
        </div>
    );
}
